webpackJsonp([1],{

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.router = undefined;

__webpack_require__(230);

var _vue = __webpack_require__(19);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(235);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(152);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(231);

__webpack_require__(233);

var _vueRouter = __webpack_require__(236);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _routes = __webpack_require__(229);

var _routes2 = _interopRequireDefault(_routes);

__webpack_require__(232);

var _vueClipboard = __webpack_require__(234);

var _vueClipboard2 = _interopRequireDefault(_vueClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueClipboard2.default);

var router = exports.router = new _vueRouter2.default({
    base: 'package',
    routes: _routes2.default
});

new _vue2.default({
    router: router,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Home = __webpack_require__(567);

var _Home2 = _interopRequireDefault(_Home);

var _Package = __webpack_require__(571);

var _Package2 = _interopRequireDefault(_Package);

var _MyPackage = __webpack_require__(568);

var _MyPackage2 = _interopRequireDefault(_MyPackage);

var _PackageRecord = __webpack_require__(572);

var _PackageRecord2 = _interopRequireDefault(_PackageRecord);

var _DonglePackageRecord = __webpack_require__(566);

var _DonglePackageRecord2 = _interopRequireDefault(_DonglePackageRecord);

var _Order = __webpack_require__(569);

var _Order2 = _interopRequireDefault(_Order);

var _OrderDetail = __webpack_require__(570);

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/',
    redirect: '/buy',
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '',
    iconCls: 'fa fa-bar-chart',
    children: [{ path: '/buy', component: _Package2.default, name: 'Buy' }, { path: '/myPackage', component: _MyPackage2.default, name: 'MyPackage' }, { path: '/packageRecord', component: _PackageRecord2.default, name: 'PackageRecord' }, { path: '/donglePackageRecord', component: _DonglePackageRecord2.default, name: 'DonglePackageRecord' }, { path: '/order', component: _Order2.default, name: 'Order' }, { path: '/orderDetail', component: _OrderDetail2.default, name: 'OrderDetail' }]
}];

exports.default = routes;

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 232:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(578),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: 'app',
	components: {}
};

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			assetGuid: '',
			packageName: '',
			chargeMode: '',
			recordListData: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			searchObj: {
				shellNo: ''
			}
		};
	},

	methods: {
		getRecordList: function getRecordList() {
			var _this = this;

			var url = '/package/asset/dongle/record.do';
			var param = {
				assetGuid: this.assetGuid,
				shellNo: this.searchObj.shellNo
			};
			param.currentPage = this.currentPage;
			param.pageSize = this.pageSize;

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.recordListData = response.data.rows;
					_this.total = response.data.records;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		licenseIdFormatter: function licenseIdFormatter(row, index) {
			if (row.licenseId == 0) {
				return '--';
			} else {
				return row.licenseId;
			};
		},
		licenseFormFormatter: function licenseFormFormatter(row, index) {
			switch (row.licenseForm) {
				case 1:
					return '云锁';
					break;
				case 2:
					return '软锁';
					break;
				case 4:
					return '硬件锁';
					break;
			};
		},
		packageTypeFormatter: function packageTypeFormatter(row, index) {
			switch (row.packageType) {
				case 1:
					return '许可套餐';
					break;
				case 2:
					return '更新次数套餐';
					break;
				case 3:
					return '硬件锁套餐';
					break;
			};
		},
		backToPage: function backToPage() {
			sessionStorage.setItem('isFirst', 1);
		},
		searchRecordList: function searchRecordList() {
			this.currentPage = 1;
			this.getRecordList();
		},
		emptySearch: function emptySearch() {
			this.searchObj.shellNo = '';
			this.currentPage = 1;
			this.getRecordList();
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getRecordList();
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getRecordList();
		}
	},
	mounted: function mounted() {
		this.assetGuid = this.$route.query.assetGuid;
		this.packageName = this.$route.query.packageName;
		this.chargeMode = this.$route.query.chargeMode;
		this.getRecordList();
	}
};

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			package_buy: false,
			package_view: false,
			order_view: false
		};
	},

	methods: {
		loadNav: function loadNav() {
			var _this = this;

			var url = '/getPrivilegesForWeb.do';
			var param = {};

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					if (response.data.package_buy) {
						_this.package_buy = true;
					};
					if (response.data.package_view) {
						_this.package_view = true;
					};
					if (response.data.order_view) {
						_this.order_view = true;
					};
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		}
	},
	mounted: function mounted() {
		this.loadNav();
	}
};

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			tabsActive: '1',

			licenseSearchObj: {
				packageName: '',
				status: '1'
			},
			licenseObj: {
				currentPage: 1,
				pageSize: 9,
				total: 0
			},
			noDataObj: {
				status: '1'
			},
			isReady: false,
			licenseListData: []
		};
	},

	filters: {
		licenseFormFilter: function licenseFormFilter(val) {
			if (val == 1) {
				return '云锁';
			} else {
				return '软锁';
			};
		},

		licensePeriodFilter: function licensePeriodFilter(val) {
			if (val == 2147483647) {
				return '永久';
			} else {
				return val + '天';
			};
		},

		donglePeriodFilter: function donglePeriodFilter(val) {
			if (val) {
				return val + '天';
			} else {
				return '--';
			};
		},

		packagePeriodFilter: function packagePeriodFilter(val) {
			if (val == 2147483647) {
				return '--';
			} else {
				return val + '天';
			};
		},

		expireTimeFilter: function expireTimeFilter(val) {
			if (!val) {
				return '--';
			} else {
				return val;
			};
		},

		chargeModeFilter: function chargeModeFilter(val) {
			if (val == 1) {
				return '按升级次数';
			} else if (val == 2) {
				return '按锁数量';
			} else {
				return '不限';
			};
		},
		commonFilter: function commonFilter(val) {
			if (val == 2147483647) {
				return '不限';
			} else {
				return val;
			};
		},

		statusFilter: function statusFilter(val) {
			switch (val) {
				case 1:
					return '正常';
					break;
				case 2:
					return '已用完';
					break;
				case 3:
					return '已过期';
					break;
			};
		},

		concurrentFilter: function concurrentFilter(hasConcurrent, concurrentType, concurrent) {
			if (hasConcurrent == false) {
				return '单机许可';
			} else {
				var concurrentTypeName = concurrentType == 'process' ? '进程' : '会话';
				return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
			};
		}
	},
	methods: {
		getLicenseList: function getLicenseList() {
			var _this = this;

			var url = '/package/asset/list.do';
			var param = this.licenseSearchObj;
			param.currentPage = this.licenseObj.currentPage;
			param.pageSize = this.licenseObj.pageSize;

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.licenseListData = response.data.rows;
					_this.licenseObj.total = response.data.records;
					_this.noDataObj.status = _this.licenseSearchObj.status;
					_this.isReady = true;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		countRecord: function countRecord(row) {
			sessionStorage.setItem('status', this.licenseSearchObj.status);

			if (row.packageType == 3) {
				this.$router.push({
					path: '/donglePackageRecord',
					query: {
						assetGuid: row.assetGuid,
						packageName: row.packageName,
						chargeMode: row.detail.chargeMode
					}
				});
			} else {
				this.$router.push({
					path: '/packageRecord',
					query: {
						assetGuid: row.assetGuid,
						packageName: row.packageName
					}
				});
			};
		},
		copySuccess: function copySuccess() {
			this.$message({
				message: '套餐序列号复制成功',
				type: 'success'
			});
		},
		searchLicenseList: function searchLicenseList() {
			this.licenseObj.currentPage = 1;
			this.getLicenseList();
		},
		emptyLicenseSearch: function emptyLicenseSearch() {
			this.licenseSearchObj.packageName = '';
			this.licenseSearchObj.status = '1';
			this.licenseObj.currentPage = 1;
			this.getLicenseList();
		},
		handleSizeChange: function handleSizeChange(val) {
			this.licenseObj.pageSize = val;
			this.getLicenseList();
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.licenseObj.currentPage = val;
			this.getLicenseList();
		}
	},
	mounted: function mounted() {
		var isFirst = sessionStorage.getItem('isFirst');
		if (isFirst == 1) {
			this.licenseSearchObj.status = sessionStorage.getItem('status');
			sessionStorage.setItem('isFirst', 0);
		}
		this.getLicenseList();
	}
};

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			orderListData: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			searchObj: {
				categoryNo: '0',
				productName: '',
				time: ''
			}
		};
	},

	methods: {
		getOrderList: function getOrderList() {
			var _this = this;

			var url = '/order/list.do';

			var param = {
				categoryNo: this.searchObj.categoryNo,
				productName: this.searchObj.productName,
				startTime: this.searchObj.time[0],
				endTime: this.searchObj.time[1],
				currentPage: this.currentPage,
				pageSize: this.pageSize
			};

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.orderListData = response.data.rows;
					_this.total = response.data.records;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		orderView: function orderView(row) {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderNo: row.orderNo
				}
			});
		},
		statusFormatter: function statusFormatter(row, index) {
			switch (row.status) {
				case 'paid':
					return '扣款成功';
					break;
				case 'unpaid':
					return '未扣款';
					break;
				case 'faild':
					return '扣款失败';
					break;
				case 'insufficient':
					return '余额不足';
					break;
			};
		},
		categoryNoFormatter: function categoryNoFormatter(row, index) {
			switch (row.categoryNo) {
				case 0:
					return '所有产品';
					break;
				case 1:
					return '许可套餐';
					break;
				case 2:
					return '更新次数套餐';
					break;
				case 3:
					return '硬件锁套餐';
					break;
			};
		},
		searchOrderList: function searchOrderList() {
			this.currentPage = 1;
			this.getOrderList();
		},
		emptySearch: function emptySearch() {
			this.searchObj.categoryNo = '0';
			this.searchObj.productName = '';
			this.searchObj.time = '';
			this.currentPage = 1;
			this.getOrderList();
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getOrderList();
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getOrderList();
		}
	},
	mounted: function mounted() {
		this.getOrderList();
	}
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			orderNo: '',
			orderDetailObj: {}
		};
	},

	filters: {
		licenseFormFilter: function licenseFormFilter(val) {
			if (val == 1) {
				return '云锁';
			} else {
				return '软锁';
			};
		},

		licensePeriodFilter: function licensePeriodFilter(licensePeriod, isForever) {
			if (isForever == true) {
				return '永久';
			} else {
				return licensePeriod + '天';
			};
		},

		donglePeriodFilter: function donglePeriodFilter(val) {
			if (val) {
				return val + '天';
			} else {
				return '--';
			};
		},

		chargeModeFilter: function chargeModeFilter(val) {
			if (val == 1) {
				return '按升级次数';
			} else if (val == 2) {
				return '按锁数量';
			} else {
				return '不限';
			};
		},
		commonFilter: function commonFilter(val, isTrue) {
			if (isTrue == true) {
				return val;
			} else {
				return '不限';
			};
		},

		packagePeriodFilter: function packagePeriodFilter(val) {
			if (val == 2147483647) {
				return '--';
			} else {
				return val + '天';
			};
		},

		expireTimeFilter: function expireTimeFilter(val) {
			if (!val) {
				return '--';
			} else {
				return val;
			};
		},

		reasonFilter: function reasonFilter(val) {
			switch (val) {
				case 1:
					return '新购';
					break;
				case 2:
					return '升级';
					break;
				case 3:
					return '续费';
					break;
			};
		},

		statusFilter: function statusFilter(val) {
			switch (val) {
				case 'paid':
					return '扣款成功';
					break;
				case 'unpaid':
					return '未扣款';
					break;
				case 'faild':
					return '扣款失败';
					break;
				case 'insufficient':
					return '余额不足';
					break;
			};
		},

		categoryNoFilter: function categoryNoFilter(val) {
			switch (val) {
				case 1:
					return '许可套餐';
					break;
				case 2:
					return '更新次数套餐';
					break;
				case 3:
					return '硬件锁套餐';
					break;
			};
		},

		concurrentFilter: function concurrentFilter(hasConcurrent, concurrentType, concurrent) {
			if (hasConcurrent == false) {
				return '单机许可';
			} else {
				var concurrentTypeName = concurrentType == 'process' ? '进程' : '会话';
				return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
			};
		}
	},
	methods: {
		loadDetailData: function loadDetailData() {
			var _this = this;

			var url = '/order/detail.do';
			var param = {
				orderNo: this.orderNo
			};

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.orderDetailObj = response.data;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		}
	},
	mounted: function mounted() {
		this.orderNo = this.$route.query.orderNo;
		this.loadDetailData();
	}
};

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			tabsActive: '1',

			licenseSearchObj: {
				packageName: ''
			},
			licenseObj: {
				currentPage: 1,
				pageSize: 9,
				total: 0
			},
			noDataObj: {
				packageName: ''
			},
			isReady: false,
			licenseListData: [],
			licenseBuyFormVisible: false,
			licenseBuyForm: {}
		};
	},

	filters: {
		licenseFormFilter: function licenseFormFilter(val) {
			if (val == 1) {
				return '云锁';
			} else {
				return '软锁';
			};
		},

		licensePeriodFilter: function licensePeriodFilter(val) {
			if (val == 2147483647) {
				return '永久';
			} else {
				return val + '天';
			};
		},

		donglePeriodFilter: function donglePeriodFilter(val) {
			if (val) {
				return val + '天';
			} else {
				return '--';
			};
		},

		packagePeriodFilter: function packagePeriodFilter(val) {
			if (val == 2147483647) {
				return '--';
			} else {
				return val + '天';
			};
		},

		expireTimeFilter: function expireTimeFilter(val) {
			if (!val) {
				return '--';
			} else {
				return val;
			};
		},

		chargeModeFilter: function chargeModeFilter(val) {
			if (val == 1) {
				return '按升级次数';
			} else if (val == 2) {
				return '按锁数量';
			} else {
				return '不限';
			};
		},
		commonFilter: function commonFilter(val) {
			if (val == 2147483647) {
				return '不限';
			} else {
				return val;
			};
		},

		concurrentFilter: function concurrentFilter(hasConcurrent, concurrentType, concurrent) {
			if (hasConcurrent == false) {
				return '单机许可';
			} else {
				var concurrentTypeName = concurrentType == 'process' ? '进程' : '会话';
				return '集团许可 ' + concurrentTypeName + '(用户数: ' + concurrent + ')';
			};
		}
	},
	methods: {
		getLicenseList: function getLicenseList() {
			var _this = this;

			var url = '/package/find.do';
			var param = this.licenseSearchObj;
			param.currentPage = this.licenseObj.currentPage;
			param.pageSize = this.licenseObj.pageSize;

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.licenseListData = response.data.rows;
					_this.licenseObj.total = response.data.records;
					_this.noDataObj.packageName = _this.licenseSearchObj.packageName;
					_this.isReady = true;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		licenseBuy: function licenseBuy(item) {
			this.licenseBuyForm = item;
			this.licenseBuyFormVisible = true;
		},
		licenseBuyFormSubmit: function licenseBuyFormSubmit() {
			var _this2 = this;

			var url = '/package/buy.do';
			var param = {
				packageGuid: this.licenseBuyForm.packageGuid
			};

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this2.licenseBuyFormVisible = false;
					_this2.$message({
						message: '套餐购买成功',
						type: 'success'
					});
				} else {
					_this2.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		searchLicenseList: function searchLicenseList() {
			this.licenseObj.currentPage = 1;
			this.getLicenseList();
		},
		emptyLicenseSearch: function emptyLicenseSearch() {
			this.licenseSearchObj.packageName = '';
			this.licenseObj.currentPage = 1;
			this.getLicenseList();
		},
		handleSizeChange: function handleSizeChange(val) {
			this.licenseObj.pageSize = val;
			this.getLicenseList();
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.licenseObj.currentPage = val;
			this.getLicenseList();
		}
	},
	mounted: function mounted() {
		this.getLicenseList();
	}
};

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _api = __webpack_require__(44);

exports.default = {
	data: function data() {
		return {
			assetGuid: '',
			packageName: '',
			recordListData: [],
			currentPage: 1,
			pageSize: 10,
			total: 0,
			searchObj: {
				account: ''
			}
		};
	},

	methods: {
		getRecordList: function getRecordList() {
			var _this = this;

			var url = '/package/asset/record.do';
			var param = {
				assetGuid: this.assetGuid,
				account: this.searchObj.account
			};
			param.currentPage = this.currentPage;
			param.pageSize = this.pageSize;

			(0, _api.ajax)(url, param).then(function (response) {
				if (response.code == 0) {
					_this.recordListData = response.data.rows;
					_this.total = response.data.records;
				} else {
					_this.$message({
						message: response.desc,
						type: 'warning'
					});
				};
			});
		},
		productNameFormatter: function productNameFormatter(row, index) {
			if (row.productName) {
				return row.productName;
			} else {
				return '--';
			};
		},
		licenseIdFormatter: function licenseIdFormatter(row, index) {
			if (row.licenseId) {
				return row.licenseId;
			} else {
				return '--';
			};
		},
		licenseFormFormatter: function licenseFormFormatter(row, index) {
			switch (row.licenseForm) {
				case 1:
					return '云锁';
					break;
				case 2:
					return '软锁';
					break;
			};
		},
		packageTypeFormatter: function packageTypeFormatter(row, index) {
			switch (row.packageType) {
				case 1:
					return '许可套餐';
					break;
				case 2:
					return '更新次数套餐';
					break;
				case 3:
					return '硬件锁套餐';
					break;
			};
		},
		backToPage: function backToPage() {
			sessionStorage.setItem('isFirst', 1);
		},
		searchRecordList: function searchRecordList() {
			this.currentPage = 1;
			this.getRecordList();
		},
		emptySearch: function emptySearch() {
			this.searchObj.account = '';
			this.currentPage = 1;
			this.getRecordList();
		},
		handleSizeChange: function handleSizeChange(val) {
			this.pageSize = val;
			this.getRecordList();
		},
		handleCurrentChange: function handleCurrentChange(val) {
			this.currentPage = val;
			this.getRecordList();
		}
	},
	mounted: function mounted() {
		this.assetGuid = this.$route.query.assetGuid;
		this.packageName = this.$route.query.packageName;
		this.getRecordList();
	}
};

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(286);

var _promise2 = _interopRequireDefault(_promise);

exports.ajax = ajax;

var _axios = __webpack_require__(259);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(558);

var _qs2 = _interopRequireDefault(_qs);

var _elementUi = __webpack_require__(152);

var _main = __webpack_require__(163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

_axios2.default.defaults.baseURL = '/';function ajax(url, params, method) {
    return new _promise2.default(function (resolve, reject) {
        if (method && method == 'get') {
            _axios2.default.get(url, _qs2.default.stringify(params)).then(function (response) {
                if (response.data.code == -2) {
                    _elementUi.MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: function callback(action) {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(function () {
                        _elementUi.MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data);
                };
            }).catch(function (error) {
                reject(error);
            });
        } else {
            _axios2.default.post(url, _qs2.default.stringify(params)).then(function (response) {
                if (response.data.code == -2) {
                    _elementUi.MessageBox.alert('会话已过期，3秒后将自动跳转到开发者中心', '会话已过期', {
                        type: 'warning',
                        showClose: false,
                        callback: function callback(action) {
                            window.location.href = 'https://developer.lm.virbox.com';
                        }
                    });
                    setTimeout(function () {
                        _elementUi.MessageBox.close();
                        window.location.href = 'https://developer.lm.virbox.com';
                    }, 3000);
                } else {
                    resolve(response.data);
                };
            }).catch(function (error) {
                reject(error);
            });
        };
    });
};

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/keep-record.d0289dc.png";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(547)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(574),
  /* scopeId */
  "data-v-080994a7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(546)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(573),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(552)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(580),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(549)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(576),
  /* scopeId */
  "data-v-1951e77b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(551)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(579),
  /* scopeId */
  "data-v-33b255a8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(550)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(577),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(548)

var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(575),
  /* scopeId */
  "data-v-1153c238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "sense-container"
  }, [_c('div', {
    staticClass: "sense-header"
  }, [_c('div', {
    staticClass: "sense-header-box clearfix"
  }, [_c('h1', {
    staticClass: "fl"
  }), _vm._v(" "), _c('div', {
    staticClass: "sense-nav fl"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#001529"
    }
  }, [_c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.package_buy),
      expression: "package_buy"
    }],
    attrs: {
      "index": "1"
    }
  }, [_c('router-link', {
    staticClass: "tag-list",
    attrs: {
      "tag": "span",
      "to": "/buy"
    }
  }, [_vm._v("购买套餐")])], 1), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.package_view),
      expression: "package_view"
    }],
    attrs: {
      "index": "2"
    }
  }, [_c('router-link', {
    staticClass: "tag-list",
    attrs: {
      "tag": "span",
      "to": "/myPackage"
    }
  }, [_vm._v("我的套餐")])], 1), _vm._v(" "), _c('el-menu-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order_view),
      expression: "order_view"
    }],
    attrs: {
      "index": "3"
    }
  }, [_c('router-link', {
    staticClass: "tag-list",
    attrs: {
      "tag": "span",
      "to": "/order"
    }
  }, [_vm._v("我的订单")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sense-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-footer"
  }, [_vm._v("\n\t\t北京深盾科技股份有限公司 ©\n\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备16009104号")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025663"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(565)
    }
  }), _vm._v("京公网安备 11010802025663号")])])])
},staticRenderFns: []}

/***/ }),

/***/ 574:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/myPackage'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.backToPage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.packageName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("使用记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-search sense-search-more clearfix"
  }, [_c('el-row', [_c('el-form', [_c('el-col', {
    attrs: {
      "span": 7,
      "offset": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "外壳号",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.searchObj.shellNo),
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "shellNo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchObj.shellNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptySearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchRecordList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis"
  }, [(_vm.chargeMode == 1) ? _c('el-table', {
    attrs: {
      "data": _vm.recordListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shellNo",
      "label": "外壳号",
      "min-width": "20%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "18%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.licenseIdFormatter,
      "label": "许可ID",
      "min-width": "16%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.licenseFormFormatter,
      "label": "许可形式",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.packageTypeFormatter,
      "label": "套餐类型",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deductCount",
      "label": "扣减数量",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "label": "使用时间",
      "min-width": "16%"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.chargeMode != 1) ? _c('el-table', {
    attrs: {
      "data": _vm.recordListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "shellNo",
      "label": "外壳号",
      "min-width": "20%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.packageTypeFormatter,
      "label": "套餐类型",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deductCount",
      "label": "扣减数量",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "label": "使用时间",
      "min-width": "16%"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 575:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/myPackage'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.backToPage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.packageName))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("使用记录")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-search sense-search-more clearfix"
  }, [_c('el-row', [_c('el-form', [_c('el-col', {
    attrs: {
      "span": 7,
      "offset": 14
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "账号/授权码",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.searchObj.account),
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "account", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchObj.account"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptySearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchRecordList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.recordListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "账号/授权码",
      "min-width": "20%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.productNameFormatter,
      "label": "产品名称",
      "min-width": "18%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.licenseIdFormatter,
      "label": "许可ID",
      "min-width": "16%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.licenseFormFormatter,
      "label": "许可形式",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.packageTypeFormatter,
      "label": "套餐类型",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deductCount",
      "label": "扣减数量",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "label": "使用时间",
      "min-width": "16%"
    }
  })], 1)], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 576:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-search"
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "68px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品类型"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.searchObj.categoryNo),
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "categoryNo", $$v)
      },
      expression: "searchObj.categoryNo"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "所有产品",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "许可套餐",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "更新次数套餐",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "硬件锁套餐",
      "value": "3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.searchObj.productName),
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "productName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchObj.productName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "扣款时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "size": "medium",
      "type": "daterange",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "unlink-panels": ""
    },
    model: {
      value: (_vm.searchObj.time),
      callback: function($$v) {
        _vm.$set(_vm.searchObj, "time", $$v)
      },
      expression: "searchObj.time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptySearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrderList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.orderListData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderNo",
      "label": "订单编号",
      "min-width": "12%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productName",
      "label": "产品名称",
      "min-width": "15%",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.categoryNoFormatter,
      "label": "产品类型",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount",
      "label": "应付金额(元)",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deductAmount",
      "label": "实付金额(元)",
      "min-width": "10%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "formatter": _vm.statusFormatter,
      "label": "订单状态",
      "min-width": "9%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createAt",
      "label": "创建时间",
      "min-width": "14%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payAt",
      "label": "支付时间",
      "min-width": "14%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "6%"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "ssicon ss-info operate-icon",
          attrs: {
            "title": "详情"
          },
          on: {
            "click": function($event) {
              return _vm.orderView(scope.row)
            }
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 30],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-search"
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "68px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.licenseSearchObj.packageName),
      callback: function($$v) {
        _vm.$set(_vm.licenseSearchObj, "packageName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "licenseSearchObj.packageName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptyLicenseSearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchLicenseList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list"
  }, [(_vm.isReady == true && _vm.licenseListData.length == 0 && !_vm.noDataObj.packageName) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("一大波优惠在路上，敬请期待")]) : _vm._e(), _vm._v(" "), (_vm.isReady == true && _vm.licenseListData.length == 0 && _vm.noDataObj.packageName) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("暂无数据")]) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-right": "-30px"
    }
  }, _vm._l((_vm.licenseListData), function(item) {
    return _c('el-col', {
      key: item.packageGuid,
      attrs: {
        "span": 8
      }
    }, [_c('el-card', {
      staticClass: "sense-card-new"
    }, [_c('div', {
      staticClass: "card-new-header clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h3', {
      staticClass: "fl sense-ellipsis",
      attrs: {
        "title": item.packageName
      }
    }, [_vm._v(_vm._s(item.packageName))]), _vm._v(" "), _c('el-popover', {
      attrs: {
        "placement": "right-start",
        "width": "270",
        "trigger": "click"
      }
    }, [_c('el-form', {
      attrs: {
        "size": "small",
        "label-width": "100px"
      }
    }, [(item.packageType == 1) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "许可形式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), (item.detail.licenseForm == 2) ? _c('el-form-item', {
      attrs: {
        "label": "系统平台"
      }
    }, [(item.detail.platform == 7) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "arm-linux-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "许可周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(item.detail.licensePeriod)))])]), _vm._v(" "), (item.detail.licenseForm == 1) ? _c('el-form-item', {
      attrs: {
        "label": "使用计数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.useCount ? item.detail.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "许可类型"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(item.detail.hasConcurrent, item.detail.concurrentType, item.detail.concurrent)))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && ((item.detail.platform == 7 && item.detail.hasConcurrent == false) || (item.detail.platform & 24) > 0)) ? _c('el-form-item', {
      attrs: {
        "label": "同时绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.bindLimit))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.hasConcurrent == false && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "累积绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.maxBound))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "label": "许可数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)))])])], 1) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('el-form-item', {
      attrs: {
        "label": "更新次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)))])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "计费方式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('el-form-item', {
      attrs: {
        "label": "升级次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐有效期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐失效日期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(item.expireTime)))])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "原价"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_c('del', [_vm._v("￥" + _vm._s(item.originPrice))])])]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐价"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v("￥" + _vm._s(item.packagePrice))])])], 1), _vm._v(" "), _c('span', {
      staticClass: "fr ssicon ss-info",
      attrs: {
        "slot": "reference"
      },
      slot: "reference"
    })], 1)], 1), _vm._v(" "), (item.packageType == 1) ? _c('ul', {
      staticClass: "card-new-con"
    }, [(item.detail.licenseForm == 2) ? _c('li', {
      staticClass: "plat"
    }, [(item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "arm-linux-big-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可形式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可周期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(item.detail.licensePeriod)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("更新次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("套餐有效期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("计费方式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("升级次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2 && item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁周期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e(), _vm._v(" "), (!item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("套餐有效期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(item.packagePeriod)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-new-footer clearfix"
    }, [_c('b', {
      staticClass: "fl"
    }, [_vm._v("￥" + _vm._s(item.packagePrice))]), _vm._v(" "), _c('del', {
      staticClass: "fl"
    }, [_vm._v("￥" + _vm._s(item.originPrice))]), _vm._v(" "), _c('el-button', {
      staticClass: "fr",
      attrs: {
        "size": "small",
        "type": "primary",
        "plain": ""
      },
      on: {
        "click": function($event) {
          return _vm.licenseBuy(item)
        }
      }
    }, [_vm._v("立即购买")])], 1)])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.licenseObj.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.licenseObj.currentPage,
      "page-sizes": [9, 18, 27],
      "page-size": _vm.licenseObj.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.licenseObj.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  }, [_c('el-dialog', {
    staticClass: "sense-dialog",
    attrs: {
      "title": "购买确认",
      "visible": _vm.licenseBuyFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.licenseBuyFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.licenseBuyForm,
      "size": "small",
      "label-width": "120px"
    }
  }, [(_vm.licenseBuyForm.packageType == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.packageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可形式"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(_vm.licenseBuyForm.detail.licenseForm)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2) ? _c('el-form-item', {
    attrs: {
      "label": "系统平台"
    }
  }, [(_vm.licenseBuyForm.detail.platform == 7) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-windows",
    attrs: {
      "title": "Windows"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-linux",
    attrs: {
      "title": "Linux"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-mac",
    attrs: {
      "title": "Mac"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.licenseBuyForm.detail.platform & 24) > 0) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-android",
    attrs: {
      "title": "Android"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "arm-linux-icon",
    attrs: {
      "title": "ARM Linux"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可周期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(_vm.licenseBuyForm.detail.licensePeriod)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 1) ? _c('el-form-item', {
    attrs: {
      "label": "使用计数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.useCount ? _vm.licenseBuyForm.detail.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && _vm.licenseBuyForm.detail.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "许可类型"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(_vm.licenseBuyForm.detail.hasConcurrent, _vm.licenseBuyForm.detail.concurrentType, _vm.licenseBuyForm.detail.concurrent)))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && ((_vm.licenseBuyForm.detail.platform == 7 && _vm.licenseBuyForm.detail.hasConcurrent == false) || (_vm.licenseBuyForm.detail.platform & 24) > 0)) ? _c('el-form-item', {
    attrs: {
      "label": "同时绑定设备数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.bindLimit))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.licenseForm == 2 && _vm.licenseBuyForm.detail.hasConcurrent == false && _vm.licenseBuyForm.detail.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "累积绑定设备数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.maxBound))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "许可数量"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.licenseBuyForm.detail.licenseCount)))])])], 1) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.packageType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "更新次数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.licenseBuyForm.detail.updateCount)))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.packageType == 3) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "计费方式"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(_vm.licenseBuyForm.detail.chargeMode)))])]), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 1) ? _c('el-form-item', {
    attrs: {
      "label": "升级次数"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.upgradeCount))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁数量"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.licenseBuyForm.detail.dongleCount))])]) : _vm._e(), _vm._v(" "), (_vm.licenseBuyForm.detail.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁周期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(_vm.licenseBuyForm.detail.donglePeriod)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐有效期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(_vm.licenseBuyForm.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐失效日期"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(_vm.licenseBuyForm.expireTime)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原价"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_c('del', [_vm._v("￥" + _vm._s(_vm.licenseBuyForm.originPrice))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐价"
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v("￥" + _vm._s(_vm.licenseBuyForm.packagePrice))])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "sense-tip-blue"
  }, [_vm._v("点击“确定”按钮将从您的账户中扣除相应费用")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.licenseBuyFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.licenseBuyFormSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/order'
      }
    }
  }, [_vm._v(_vm._s(_vm.orderNo))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("订单详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list sense-table-ellipsis sense-detail"
  }, [_c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("概要")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.orderNo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产生原因："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("reasonFilter")(_vm.orderDetailObj.reason)))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单状态："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("statusFilter")(_vm.orderDetailObj.status)))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "创建时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.createAt))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "支付时间："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.payAt))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("产品信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品分类："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("categoryNoFilter")(_vm.orderDetailObj.categoryNo)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "产品名称："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.buyCount))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "价格："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.price))])])], 1), _vm._v(" "), (_vm.orderDetailObj.productInfo) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可形式："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(_vm.orderDetailObj.productInfo.licenseForm)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可周期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(_vm.orderDetailObj.productInfo.licensePeriod, _vm.orderDetailObj.productInfo.isForever)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 1) ? _c('el-form-item', {
    attrs: {
      "label": "使用计数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.useCount ? _vm.orderDetailObj.productInfo.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && _vm.orderDetailObj.productInfo.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "许可类型："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(_vm.orderDetailObj.productInfo.hasConcurrent, _vm.orderDetailObj.productInfo.concurrentType, _vm.orderDetailObj.productInfo.concurrent)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && ((_vm.orderDetailObj.productInfo.platform == 7 && _vm.orderDetailObj.productInfo.hasConcurrent == false) || (_vm.orderDetailObj.productInfo.platform & 24) > 0)) ? _c('el-form-item', {
    attrs: {
      "label": "同时绑定数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.bindLimit))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo.licenseForm == 2 && _vm.orderDetailObj.productInfo.hasConcurrent == false && _vm.orderDetailObj.productInfo.platform == 7) ? _c('el-form-item', {
    attrs: {
      "label": "累积绑定数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.maxBound))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.productInfo) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [(_vm.orderDetailObj.categoryNo == 1 && _vm.orderDetailObj.productInfo.licenseForm == 2) ? _c('el-form-item', {
    attrs: {
      "label": "系统平台："
    }
  }, [(_vm.orderDetailObj.productInfo.platform == 7) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-windows",
    attrs: {
      "title": "Windows"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-linux",
    attrs: {
      "title": "Linux"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "ssicon ss-mac",
    attrs: {
      "title": "Mac"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((_vm.orderDetailObj.productInfo.platform & 24) > 0) ? _c('div', {
    staticClass: "sense-text",
    staticStyle: {
      "position": "relative",
      "top": "-2px"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t"), _c('em', {
    staticClass: "ssicon ss-android",
    attrs: {
      "title": "Android"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "arm-linux-icon",
    attrs: {
      "title": "ARM Linux"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 1) ? _c('el-form-item', {
    attrs: {
      "label": "许可数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.orderDetailObj.productInfo.licenseCount, _vm.orderDetailObj.productInfo.hasLicenseCount)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 2) ? _c('el-form-item', {
    attrs: {
      "label": "更新次数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("commonFilter")(_vm.orderDetailObj.productInfo.updateCount, _vm.orderDetailObj.productInfo.hasUpdateCount)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3) ? _c('el-form-item', {
    attrs: {
      "label": "计费方式："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(_vm.orderDetailObj.productInfo.chargeMode)))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 1) ? _c('el-form-item', {
    attrs: {
      "label": "升级次数："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.upgradeCount))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁数量："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.productInfo.dongleCount))])]) : _vm._e(), _vm._v(" "), (_vm.orderDetailObj.categoryNo == 3 && _vm.orderDetailObj.productInfo.chargeMode == 2) ? _c('el-form-item', {
    attrs: {
      "label": "硬件锁周期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(_vm.orderDetailObj.productInfo.donglePeriod)))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐有效期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("packagePeriodFilter")(_vm.orderDetailObj.productInfo.packagePeriod)))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐失效日期："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(_vm.orderDetailObj.productInfo.expireTime)))])])], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-detail-block"
  }, [_c('h3', [_vm._v("结算信息")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "110px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应付金额："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.amount))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实付金额："
    }
  }, [_c('div', {
    staticClass: "sense-text"
  }, [_vm._v(_vm._s(_vm.orderDetailObj.deductAmount))])])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "all-dialog"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sense-main"
  }, [_c('div', {
    staticClass: "sense-search"
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "68px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6,
      "offset": 9
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐名称"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.licenseSearchObj.packageName),
      callback: function($$v) {
        _vm.$set(_vm.licenseSearchObj, "packageName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "licenseSearchObj.packageName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "套餐状态"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "maxlength": "64"
    },
    model: {
      value: (_vm.licenseSearchObj.status),
      callback: function($$v) {
        _vm.$set(_vm.licenseSearchObj, "status", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "licenseSearchObj.status"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "value": "1",
      "label": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "value": "2",
      "label": "已用完"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "value": "3",
      "label": "已过期"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.emptyLicenseSearch
    }
  }, [_vm._v("清空")]), _vm._v(" "), _c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.searchLicenseList
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-table-list"
  }, [(_vm.isReady == true && _vm.licenseListData.length == 0 && _vm.noDataObj.status == 1) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("您的账户没有可用套餐")]) : _vm._e(), _vm._v(" "), (_vm.isReady == true && _vm.licenseListData.length == 0 && _vm.noDataObj.status == 2) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("您的账户没有已用完套餐")]) : _vm._e(), _vm._v(" "), (_vm.isReady == true && _vm.licenseListData.length == 0 && _vm.noDataObj.status == 3) ? _c('div', {
    staticClass: "package-no-data"
  }, [_vm._v("您的账户没有已过期套餐")]) : _vm._e(), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-right": "-30px"
    }
  }, _vm._l((_vm.licenseListData), function(item) {
    return _c('el-col', {
      key: item.packageGuid,
      attrs: {
        "span": 8
      }
    }, [_c('el-card', {
      staticClass: "sense-card-new"
    }, [_c('div', {
      staticClass: "card-new-header clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('h3', {
      staticClass: "fl sense-ellipsis",
      attrs: {
        "title": item.packageName
      }
    }, [_vm._v(_vm._s(item.packageName))]), _vm._v(" "), _c('el-tag', {
      staticClass: "fr",
      attrs: {
        "size": "mini",
        "type": item.status == 1 ? 'success' : 'info'
      }
    }, [_vm._v(_vm._s(_vm._f("statusFilter")(item.status)))])], 1), _vm._v(" "), (item.packageType == 1) ? _c('ul', {
      staticClass: "card-new-con"
    }, [(item.detail.licenseForm == 2) ? _c('li', {
      staticClass: "plat"
    }, [(item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }) : _vm._e(), _vm._v(" "), (item.detail.platform == 7) ? _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('em', {
      staticClass: "arm-linux-big-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可形式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("许可数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl sense-ellipsis package-num"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)) + "/" + _vm._s(_vm._f("commonFilter")(item.detail.licenseTotal)) + " (剩余/总量)")])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("到期时间")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.expireTime))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("更新次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl sense-ellipsis package-num"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)) + "/" + _vm._s(_vm._f("commonFilter")(item.detail.updateTotal)) + " (剩余/总量)")])]), _vm._v(" "), _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("到期时间")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.expireTime))])])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('ul', {
      staticClass: "card-new-con"
    }, [_c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("计费方式")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("升级次数")]), _vm._v(" "), _c('span', {
      staticClass: "fl sense-ellipsis package-num"
    }, [_vm._v(_vm._s(item.detail.upgradeCount + '/' + item.detail.upgradeTotal) + " (剩余/总量)")])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁数量")]), _vm._v(" "), _c('span', {
      staticClass: "fl sense-ellipsis package-num"
    }, [_vm._v(_vm._s(item.detail.dongleCount + '/' + item.detail.dongleTotal) + " (剩余/总量)")])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2 && item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("硬件锁周期")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e(), _vm._v(" "), (!item.detail.donglePeriod) ? _c('li', {
      staticClass: "clearfix"
    }, [_c('label', {
      staticClass: "fl"
    }, [_vm._v("到期时间")]), _vm._v(" "), _c('span', {
      staticClass: "fl"
    }, [_vm._v(_vm._s(item.expireTime))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-new-footer clearfix"
    }, [_c('el-popover', {
      attrs: {
        "placement": "bottom",
        "width": "280",
        "trigger": "click"
      }
    }, [_c('el-form', {
      attrs: {
        "size": "small",
        "label-width": "110px"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "套餐序列号"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_c('span', {
      staticClass: "fl sense-ellipsis sense-copy-text"
    }, [_vm._v(_vm._s(item.assetGuid))]), _vm._v(" "), _c('a', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (item.assetGuid),
        expression: "item.assetGuid",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }],
      staticClass: "fr ssicon ss-copy",
      attrs: {
        "href": "javascript:;",
        "title": "复制"
      }
    })])]), _vm._v(" "), (item.packageType == 1) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "许可形式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licenseFormFilter")(item.detail.licenseForm)))])]), _vm._v(" "), (item.detail.licenseForm == 2) ? _c('el-form-item', {
      attrs: {
        "label": "系统平台"
      }
    }, [(item.detail.platform == 7) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t传统 (\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-windows",
      attrs: {
        "title": "Windows"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-linux",
      attrs: {
        "title": "Linux"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "ssicon ss-mac",
      attrs: {
        "title": "Mac"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), ((item.detail.platform & 24) > 0) ? _c('div', {
      staticClass: "sense-text",
      staticStyle: {
        "position": "relative",
        "top": "-2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t智能(\n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('em', {
      staticClass: "ssicon ss-android",
      attrs: {
        "title": "Android"
      }
    }), _vm._v(" "), _c('em', {
      staticClass: "arm-linux-icon",
      attrs: {
        "title": "ARM Linux"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "许可周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("licensePeriodFilter")(item.detail.licensePeriod)))])]), _vm._v(" "), (item.detail.licenseForm == 1) ? _c('el-form-item', {
      attrs: {
        "label": "使用计数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.useCount ? item.detail.useCount : '--'))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "许可类型"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("concurrentFilter")(item.detail.hasConcurrent, item.detail.concurrentType, item.detail.concurrent)))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && ((item.detail.platform == 7 && item.detail.hasConcurrent == false) || (item.detail.platform & 24) > 0)) ? _c('el-form-item', {
      attrs: {
        "label": "同时绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.bindLimit))])]) : _vm._e(), _vm._v(" "), (item.detail.licenseForm == 2 && item.detail.hasConcurrent == false && item.detail.platform == 7) ? _c('el-form-item', {
      attrs: {
        "label": "累积绑定数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.maxBound))])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "label": "许可数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.licenseCount)) + "/" + _vm._s(_vm._f("commonFilter")(item.detail.licenseTotal)) + " (剩余/总量)")])])], 1) : _vm._e(), _vm._v(" "), (item.packageType == 2) ? _c('el-form-item', {
      attrs: {
        "label": "更新次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("commonFilter")(item.detail.updateCount)) + "/" + _vm._s(_vm._f("commonFilter")(item.detail.updateTotal)) + " (剩余/总量)")])]) : _vm._e(), _vm._v(" "), (item.packageType == 3) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "计费方式"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("chargeModeFilter")(item.detail.chargeMode)))])]), _vm._v(" "), (item.detail.chargeMode == 1) ? _c('el-form-item', {
      attrs: {
        "label": "升级次数"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.upgradeCount + '/' + item.detail.upgradeTotal) + " (剩余/总量)")])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁数量"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(item.detail.dongleCount + '/' + item.detail.dongleTotal) + " (剩余/总量)")])]) : _vm._e(), _vm._v(" "), (item.detail.chargeMode == 2) ? _c('el-form-item', {
      attrs: {
        "label": "硬件锁周期"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("donglePeriodFilter")(item.detail.donglePeriod)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "套餐到期时间"
      }
    }, [_c('div', {
      staticClass: "sense-text"
    }, [_vm._v(_vm._s(_vm._f("expireTimeFilter")(item.expireTime)))])])], 1), _vm._v(" "), _c('a', {
      staticClass: "link fl",
      attrs: {
        "slot": "reference",
        "href": "javascript:;"
      },
      slot: "reference"
    }, [_vm._v("查看详情")])], 1), _vm._v(" "), _c('a', {
      staticClass: "link fr",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.countRecord(item)
        }
      }
    }, [_vm._v("使用记录")])], 1)])], 1)
  }), 1)], 1), _vm._v(" "), (_vm.licenseObj.total > 0) ? _c('div', {
    staticClass: "sense-table-pager"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": _vm.licenseObj.currentPage,
      "page-sizes": [9, 18, 27],
      "page-size": _vm.licenseObj.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.licenseObj.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ })

},[163]);


// WEBPACK FOOTER //
// static/js/app.08df9e0f3203c67fc4b7.js